import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CarteraRoutingModule } from './cartera-routing.module';
import { EtiquetasGestionModule } from './modules/etiquetas-gestion/etiquetas-gestion.module';
import { AcuerdoPagoModule } from './modules/acuerdo-pago/acuerdo-pago.module';
import { ReportesModule } from './modules/reportes/reportes.module';
import { CargueModule } from './modules/cargue/cargue.module';
import { SimuladorModule } from './modules/simulador/simulador.module';
import { CajerosModule } from './modules/cajeros/cajeros.module';
import { RediferidosModule } from './modules/rediferidos/rediferidos.module';

@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    CarteraRoutingModule,
    EtiquetasGestionModule,
    ReportesModule,
    AcuerdoPagoModule,
    CargueModule, CajerosModule,
    SimuladorModule,
    RediferidosModule,
  ]
})
export class CarteraModule { }
